module.exports = __webpack_public_path__ + "static/img/s2_rule_02.6db7fbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/crossYear/stage-01/popup/s2_rule_02.png
// module id = wDdD
// module chunks = 1